/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// react-routers components
import { Link, useNavigate } from "react-router-dom";

// prop-types is library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDButton from "components/MDButton";
import { updateUser } from "services/apiService";
import SuggestionsLoader from "components/SkeletonLoader/suggestionsLoader";
import { getUserList } from "services/apiService";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserAppSuggestions } from "Store/slices/Sugg&NotificationSlice";
import { fetchSuggestions } from "Store/slices/Sugg&NotificationSlice";
import { fetchCurrentUserInfo } from "Store/slices/userInfoSlice";

function SuggestionList({ title, profiles, shadow, update }) {
  const dispatch = useDispatch();
  const { userAppSuggestions, suggestionIsLoading } = useSelector(
    (state) => state.userSuggestionAndNotifications
  );
  let navigate = useNavigate();
  const [suggestionList, setSuggestionList] = useState([]);
  const [suggestionLoader, setSuggestionLoader] = useState(true);
  const [statusUpdateBoolean, setStatusUpdateBoolean] = useState(false);

  const fetchSuggestionList = async () => {
    // const getUserListRes = await getUserList();
    // console.log("getUserListRes", getUserListRes);
    // if (getUserListRes.status === 200) {
    //   dispatch(getUserAppSuggestions(getUserListRes.data.slice(0, 5)));
    // } else {
    //   dispatch(getUserAppSuggestions([]));
    // }

    dispatch(fetchSuggestions());
  };

  // const fetchUserList = async () => {
  //   setSuggestionLoader(true);
  //   const getUserListRes = await getUserList();
  //   // console.log("getUserListRes", getUserListRes);
  //   if (getUserListRes.status === 200) {
  //     setSuggestionList(getUserListRes.data.slice(0, 4));
  //     setSuggestionLoader(false);
  //   } else {
  //     setSuggestionList([]);
  //     setSuggestionLoader(false);
  //   }
  // };

  const handleFollowUnfollow = async (username) => {
    const updateData = {
      followers: username,
    };
    const updateUserRes = await updateUser(updateData);

    if (updateUserRes.status === 200) {
      fetchSuggestionList();
      dispatch(fetchCurrentUserInfo(localStorage.userNameSingh));
    }
  };

  const handleUsernameClick = (username) => {
    navigate(`/profile/?username=${username}`);
  };

  // useEffect(() => {
  //   // if (suggestionIsLoading) {
  //   fetchSuggestionList();
  //   // }
  // }, []);

  const renderProfiles = userAppSuggestions.map(
    ({ pic, username, fullName, action, followers }) => (
      <MDBox
        key={username}
        // component="li"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        py={1}
        mb={1}
      >
        <MDBox mr={2} display="flex" gap="0.5rem" alignItems="center">
          <MDAvatar
            src={pic}
            alt="something here"
            shadow="md"
            size="sm"
            imgProps={{
              style: { height: "100%", width: "100%" },
            }}
            sx={{ cursor: "pointer" }}
            onClick={() => handleUsernameClick(username)}
          />
          <MDBox
            display="flex"
            flexDirection="column"
            alignItems="flex-start"
            justifyContent="center"
            sx={{ cursor: "pointer" }}
            onClick={() => handleUsernameClick(username)}
          >
            <MDTypography variant="button" fontWeight="medium">
              {username}
            </MDTypography>
            <MDTypography variant="caption" color="text">
              {fullName}
            </MDTypography>
          </MDBox>
        </MDBox>

        <MDBox>
          <MDButton
            sx={{ margin: 0, padding: 0 }}
            variant="text"
            color="singh"
            onClick={() => handleFollowUnfollow(username)}
          >
            + Follow
          </MDButton>
        </MDBox>
      </MDBox>
    )
  );

  return (
    // <Card sx={{ height: "100%", boxShadow: !shadow && "none" }}>
    <>
      <MDBox marginBottom="1rem">
        <MDTypography
          //   variant="h6"
          fontWeight="medium"
          //   textTransform="capitalize"
        >
          {title}
        </MDTypography>
      </MDBox>
      <MDBox>
        {suggestionIsLoading ? (
          <SuggestionsLoader />
        ) : (
          <MDBox
            // component="ul"
            // display="flex"
            // flexDirection="column"
            p={0}
            m={0}
          >
            {renderProfiles}
          </MDBox>
        )}
      </MDBox>
    </>
    // </Card>
  );
}

// Setting default props for the ProfilesList
SuggestionList.defaultProps = {
  shadow: true,
};

// Typechecking props for the ProfilesList
SuggestionList.propTypes = {
  title: PropTypes.string.isRequired,
  // profiles: PropTypes.arrayOf(PropTypes.object).isRequired,
  shadow: PropTypes.bool,
};

export default SuggestionList;
